export default "__VITE_ASSET__BMQNkyNQ__"